module.exports = __webpack_public_path__ + "img/teamviewer.490276e3.png";